<template>
	<div class="Profile_Form">
		<div class="grid-x grid-margin-x">
			<div class="cell small-12">
				<h4 class="Profile_Form__headline Profile_Form__headline--no-margin">
					{{ $t('companion.personalHeading') }}
				</h4>
			</div>
			<div class="cell small-12 medium-6">
				<InputComponent
					v-model="user.name"
					:label="$t('newaccount.firstNamePlaceholder') + ':'"
					:mandatory="true"
					:hasError="validation.name.error"
					:errorMessage="validation.name.message"
					:redErrorColor="true"
				></InputComponent>
			</div>
			<div class="cell small-12 medium-6">
				<InputComponent
					v-model="user.lastname"
					:label="$t('newaccount.lastNamePlaceholder') + ':'"
					:mandatory="true"
					:hasError="validation.lastname.error"
					:errorMessage="validation.lastname.message"
					:redErrorColor="true"
				></InputComponent>
			</div>
		</div>
		<div class="grid-x grid-margin-x">
			<div class="cell small-12">
				<h4 class="Profile_Form__headline">
					{{ $t('companion.contactHeading') }}
				</h4>
			</div>

			<div class="cell small-12 medium-8">
				<InputComponent
					v-model="user.email"
					:label="$t('login.emailPlaceholder') + ':'"
					:placeholderValue="$t('login.emailPlaceholder')"
					:mandatory="true"
					:hasError="validation.email.error"
					:errorMessage="validation.email.message"
					:redErrorColor="true"
				></InputComponent>
			</div>

			<div class="cell small-12 medium-6">
				<div class="Profile_Form__input">
					<label class="Profile_Form__label">
						{{ $t('newaccount.phoneNumberPlaceholder') }}:
						<span>*</span>
					</label>
					<div class="grid-x grid-margin-x">
						<div class="cell small-12 medium-4">
							<InputComponent
								v-model="user.mobilephoneprefix"
								:hasError="validation.mobilephoneprefix.error"
								:errorMessage="validation.mobilephoneprefix.message"
								:mandatory="true"
								:redErrorColor="true"
							/>
						</div>
						<div class="cell small-12 medium-8">
							<InputComponent
								v-model="user.mobilephone"
								:hasError="validation.mobilephone.error"
								:errorMessage="validation.mobilephone.message"
								:mandatory="true"
								:redErrorColor="true"
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="cell small-12 medium-8">
				<InputComponent
					v-model="user.address"
					:label="$t('newaccount.addressPlaceholder') + ':'"
					:hasError="validation.address.error"
					:errorMessage="validation.address.message"
					:mandatory="true"
					:redErrorColor="true"
				></InputComponent>
			</div>
		</div>

		<div class="grid-x grid-margin-x">
			<div class="cell small-12 medium-3">
				<InputComponent
					v-model="user.zipcode"
					:label="$t('newaccount.zipcodePlaceholder') + ':'"
					:hasError="validation.zipcode.error"
					:errorMessage="validation.zipcode.message"
					:mandatory="true"
					:redErrorColor="true"
				></InputComponent>
			</div>

			<div class="cell small-12 medium-5">
				<InputComponent
					v-model="user.city"
					:label="$t('newaccount.cityPlaceholder') + ':'"
					:hasError="validation.city.error"
					:errorMessage="validation.city.message"
					:mandatory="true"
					:redErrorColor="true"
				></InputComponent>
			</div>

			<div class="cell small-12 medium-6">
				<Select
					v-model="user.country"
					:label="$t('newaccount.countryPlaceholder') + ':'"
					:defaultSelectedValue="selectedCountry"
					:placeholder="$t('newaccount.countrySelectPlaceholder')"
					:mandatory="true"
					:option-items="countryArray"
				/>
				<div class="cell small-12">
					<p v-if="settingsInfo != ''">
						<span
							:class="[
								'Profile_Form__saved',
								{ 'Profile_Form__saved--failed': !settingsUpdated }
							]"
						>
							{{ settingsInfo }}
						</span>
					</p>
				</div>
			</div>

			<div class="cell small-12 Profile_Form__button">
				<Button size="small" :loading="loading" @click.native="updateUser">
					{{ $t('edit.saveButton') }}
				</Button>
			</div>
		</div>
	</div>
</template>

<script>
import {
	testBasic,
	testPhoneNumber,
	testPrefix,
	testEmail,
	validationErrors
} from '../../../utilities/validation'
import store from '../../../vueX/store'
import { selectOptions } from '../../../data/data'
import Button from '../../atoms/Button'
import InputComponent from '../../atoms/InputComponent'
import Select from '../../../components/atoms/Select'

export default {
	name: 'Profile_Form',
	data: () => {
		return {
			loading: false,
			showModal: false,
			user: {},
			country: 'SE',
			selectedCountry: 'SE',
			countryArray: [{}],
			validation: validationErrors,
			options: selectOptions,
			settingsUpdated: false,
			settingsInfo: ''
		}
	},
	components: {
		Button,
		InputComponent,
		Select
	},
	props: {},
	beforeMount() {
		// Deep clone user
		this.user = JSON.parse(JSON.stringify(this.storeUser))
		this.selectedCountry = this.user.country
	},
	methods: {
		validate() {
			let allIsValid = true

			// reset errors and message
			Object.keys(this.validation).map(key => {
				this.validation[key].error = false
				this.validation[key].message = ''
			})

			if (!testBasic(this.user.name)) {
				this.validation.name.error = true
				this.validation.name.message = this.$t('errorText.name')
				allIsValid = false
			}

			if (!testBasic(this.user.lastname)) {
				this.validation.lastname.error = true
				this.validation.lastname.message = this.$t('errorText.lastname')
				allIsValid = false
			}
			if (!testEmail(this.user.email)) {
				this.validation.email.error = true
				this.validation.email.message = this.$t('errorText.email')
				allIsValid = false
			}

			if (!testBasic(this.user.address)) {
				this.validation.address.error = true
				this.validation.address.message = this.$t('errorText.address')
				allIsValid = false
			}

			if (!testPrefix(this.user.mobilephoneprefix)) {
				this.validation.mobilephoneprefix.error = true
				this.validation.mobilephoneprefix.message = this.$t('errorText.prefix')
				allIsValid = false
			}

			if (!testPhoneNumber(this.user.mobilephone)) {
				this.validation.mobilephone.error = true
				this.validation.mobilephone.message = this.$t('errorText.phoneNumber')
				allIsValid = false
			}
			if (!testBasic(this.user.zipcode)) {
				this.validation.zipcode.error = true
				this.validation.zipcode.message = this.$t('errorText.zipcode')
				allIsValid = false
			}
			if (!testBasic(this.user.city)) {
				this.validation.city.error = true
				this.validation.city.message = this.$t('errorText.city')
				allIsValid = false
			}

			return allIsValid
		},
		save() {
			this.loading = true
			this.updateUser()
		},
		updateUser() {
			this.loading = true

			if (this.validate()) {
				store
					.dispatch('PUT_USER', this.user)
					.then(success => {
						if (success) {
							this.loading = false
							this.settingsUpdated = true
							this.settingsInfo = this.$t('edit.settingsUpdateSuccess')
							//this.$router.push({ name: 'profile' })
						} else {
							this.settingsUpdated = false
							this.settingsInfo = this.$t('edit.settingsUpdateError')
							this.loading = false
						}
					})
					.catch(function (error) {
						this.loading = false
						window.console.warn('Failed to update user')
						window.console.warn(error)
					})
			} else {
				this.loading = false
			}
		}
	},
	computed: {
		storeUser() {
			return store.state.user
		}
	},
	created() {
		store.dispatch('GET_COUNTRIES').then(data => {
			this.countryArray = data
			const newCountryArray = data.map(item => {
				return { id: item.isocode, text: item.name }
			})
			this.countryArray = newCountryArray
		})
	}
}
</script>

<style scoped lang="scss">
.Profile_Form {
	background-color: white;
	&__headline {
		margin-top: 20px;
		padding-top: 20px;
		border-top: 1px solid #d4d8df;
		&--no-margin {
			margin-top: 0;
		}
	}

	&__label {
		/*margin-bottom: 10px;
		color: $colorPrimary;
		display: flex;
		align-items: center;*/
		display: block;
		color: #697791;
		font-family: Saira;
		font-size: 15px;
		line-height: 24px;
		margin-bottom: 0;
		span {
			font-size: 15px;
			color: #e15b5b;
			margin-left: -3px;
		}
	}

	&__input {
		display: flex;
		flex-direction: column;
		margin-top: 10px;
		&--phone {
			margin-top: 0;
			flex-direction: row;
			div:first-child {
				width: 80px;
				margin-right: 20px;
			}
		}
	}
	&__button {
		margin-top: 40px;
		margin-bottom: 40px;
		border-top: 1px solid #ccc;
		padding-top: 40px;
		text-align: right;
	}

	&__saved {
		display: block;
		color: $colorGreen;
		margin-top: 10px;
		&--failed {
			color: $colorRed;
		}
	}

	.info {
		width: 24px;
		height: 24px;
		margin-left: 10px;
		fill: $colorPrimary6;

		&:hover {
			cursor: pointer;
			fill: $colorSecondary;
		}
	}

	.modal {
		.info {
			margin: 0 10px 0 0;
		}
		h4 {
			display: flex;
			align-items: center;
			font-weight: 400;
		}
		p {
			margin: 20px 0;
		}
	}
}
</style>
